export class Badge {
  tooltip: string;
  static readonly TYPE = {
    "USER": "user",
    "ORGANIZATION": "organization"
  }

  constructor(
    public image: string,
    public link: string = "",
    public type: string = 'user'
  ) { }

  setTooltip(tooltip: string) {
    this.tooltip = tooltip
    return this;
  }
}

export class Slide {
  title: string;
  subtitle: string;
  badges: Badge[] = [];
  static readonly TYPE = {
    "BLOG": "Blog",
    "PROJECT": "Project",
    "COMPETITION": "Competition",
    "PRODUCT": "Product"
  }

  constructor(
    public image: string,
    public link: string,
    public type: string,
    public optimizer?: boolean
  ) { }

  setTitle(
    title: string,
    subtitle: string = ''
  ) {
    this.title = title;
    this.subtitle = subtitle;
    return this;
  }

  addBadge(badge: Badge) {
    this.badges.push(badge);
    return this;
  }
}
